import { handleActions } from 'redux-actions';

const defaultState = [];

export const reducer = handleActions(
  {},

  defaultState
);
